// Navigation Konfiguration für die Seitenleiste
export const adminNavItems = [
  {
    title: null, // Kein Titel für die erste Gruppe
    items: [
      {
        name: 'Dashboard',
        path: '/admin/dashboard',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>`,
        roles: ['admin', 'manager', 'staff', 'waiter']
      },
      {
        name: 'Bestellungen',
        path: '/admin/orders',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
              </svg>`,
        roles: ['admin', 'manager', 'staff', 'waiter']
      },
      {
        name: 'Küche',
        path: '/admin/kitchen',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
              </svg>`,
        roles: ['admin', 'manager', 'staff']
      },
      {
        name: 'Kellner',
        path: '/admin/waiter-dashboard',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
               </svg>`,
        roles: ['admin', 'manager', 'waiter']
      }
    ]
  },
  {
    title: 'Menüverwaltung',
    items: [
      {
        name: 'Produkte',
        path: '/admin/products',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>`,
        roles: ['admin', 'manager']
      },
      {
        name: 'Kategorien',
        path: '/admin/categories',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
              </svg>`,
        roles: ['admin', 'manager']
      },
      {
        name: 'Extras',
        path: '/admin/extras',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>`,
        badge: {
          text: 'Neu',
          class: 'bg-green-100 text-green-800 text-xs px-2 py-0.5 rounded-full animate-pulse'
        },
        roles: ['admin', 'manager']
      }
    ]
  },
  {
    title: 'System',
    items: [
      {
        name: 'Tische',
        path: '/admin/tables',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>`,
        roles: ['admin', 'manager']
      },
      {
        name: 'Benutzer',
        path: '/admin/users',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>`,
        roles: ['admin', 'manager']
      },
      {
        name: 'Berichte',
        path: '/admin/reports',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>`,
        roles: ['admin', 'manager']
      },
      {
        name: 'Einstellungen',
        path: '/admin/settings',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>`,
        roles: ['admin', 'manager']
      }
    ]
  },
  {
    title: 'Gamification & KI',
    items: [
      {
        name: 'Features & KI',
        path: '/admin/gamification',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>`,
        badge: {
          text: 'Neu',
          class: 'bg-purple-100 text-purple-800 text-xs px-2 py-0.5 rounded-full animate-pulse'
        },
        roles: ['admin', 'manager']
      },
      {
        name: 'Battle Royale',
        path: '/admin/battle-royale',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
              </svg>`,
        roles: ['admin', 'manager']
      }
    ]
  }
]

export const superAdminNavItems = [
  {
    title: null,
    items: [
      {
        name: 'Dashboard',
        path: '/superadmin/dashboard',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>`,
        roles: ['superadmin']
      },
      {
        name: 'Restaurants',
        path: '/superadmin/restaurants',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>`,
        roles: ['superadmin']
      },
      {
        name: 'Onboarding',
        path: '/superadmin/onboarding',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>`,
        badge: { text: 'Wizard', class: 'bg-gradient-to-r from-purple-500 to-indigo-500 text-white text-xs px-2 py-0.5 rounded-full' },
        roles: ['superadmin']
      }
    ]
  },
  {
    title: 'Gamification & KI',
    items: [
      {
        name: 'Features & KI',
        path: '/superadmin/gamification',
        icon: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>`,
        badge: {
          text: 'Neu',
          class: 'bg-purple-100 text-purple-800 text-xs px-2 py-0.5 rounded-full animate-pulse'
        },
        roles: ['superadmin']
      }
    ]
  }
]

/**
 * Hilfsfunktion, um Navigationseinträge basierend auf der Benutzerrolle zu filtern
 * @param {Array} navItems - Navigationsobjekt mit Abschnitten und Einträgen
 * @param {String} userRole - Die Rolle des aktuellen Benutzers
 * @returns {Array} Gefilterte Navigation
 */
export function filterNavItemsByRole(navItems, userRole) {
  if (!userRole) return [];
  
  const normalizedUserRole = userRole.toLowerCase();
  
  return navItems.map(section => {
    // Kopiere den Abschnitt
    const filteredSection = { ...section };
    
    // Filtere die Elemente nach Rolle
    filteredSection.items = section.items.filter(item => {
      // Wenn keine Rollenangabe, zeige allen
      if (!item.roles || item.roles.length === 0) return true;
      
      // Prüfe, ob die Rolle des Benutzers in den erlaubten Rollen enthalten ist
      return item.roles.map(r => r.toLowerCase()).includes(normalizedUserRole);
    });
    
    return filteredSection;
  }).filter(section => section.items.length > 0); // Nur Abschnitte mit Einträgen
} 